module.exports = __webpack_public_path__ + "static/media/veryvell_5.32edf91b.png";